import firebase from "firebase/app";
import "firebase/auth";

/**
 * Sign in to firebase with email and password
 * @param {string} email
 * @param {string} password
 * @returns Promise object of the sign in method
 */
function emailPasswordLogin(email, password) {
  return new Promise((resolve, reject) => {
    firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      .then(signInRes => {
        resolve(signInRes);
      })
      .catch(signInErr => {
        reject(signInErr);
      });
  });
}

/**
 * Rest firebase password
 * @param {string} email
 * @param {string} uid
 * @returns Promise object of the sign in method
 */

function resetPassword(uid, password) {
  return new Promise((resolve, reject) => {
    // var user = firebase.auth().currentUser;

    firebase
      .auth()
      //.updateCurrentUser(user)
      .updateUser(uid, {
        password: password
      })
      .then(userRecord => {
        console.log("Successfully updated user", userRecord.toJSON());
        resolve(userRecord);
      })
      .catch(error => {
        console.log("Error updating user:", error);
        reject(error);
      });
  });
}
/**
 * Register an account with email and password on firebase
//  * @param {string} email
//  * @param {string} password
//  */
// function emailPasswordRegister(email, password) {
//   return new Promise((resolve, reject) => {
//     firebase
//       .auth()
//       .createUserWithEmailAndPassword(email, password)
//       .then(createUserRes => {
//         resolve(createUserRes);
//       })
//       .catch(createUserErr => {
//         reject(createUserErr);
//       });
//   });
// }

/**
 * Register an account with email and password on firebase
//  * @param {string} email
//  * @param {string} password
//  */
function sendPasswordResetEmail(email) {
  return new Promise((resolve, reject) => {
    firebase
      .auth()
      .sendPasswordResetEmail(email)
      .then(res => {
        resolve({ sent: true });
      })
      .catch(err => {
        reject(err);
      });
  });
}

export default {
  data: function() {
    return {
      // adminInvite: { sending: false, email: "" },
      // headAdminInvite: { sending: false, email: "" },
      // teacherInvite: { sending: false, email: "" },
      // guardianInvite: { sending: false, email: "" }
    };
  },
  methods: {
    emailPasswordLogin,
    //emailPasswordRegister,
    sendPasswordResetEmail,
    resetPassword
  }
};
